/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-11-29 20:05:55
 * @Description: 
 */

import { configure, observable } from "mobx";
import { FTGetSubscriptions, FTGetUserPanelType } from "src/server/api";
import utils, { FTGetLocalData, FTSaveLocalData } from "src/utils";
import { FTUserStoreType } from "./types";
import FTImageStore from 'src/store/FTImageStore';
import { FTGetAdShowCountry } from './../server/api';
// mobx 配置
configure({
  enforceActions: "never" // 允许直接修改状态
});

const FTUserStore = observable.object<FTUserStoreType>({
  userInfo: null,
  isVip: false,
  isSvip: false,
  showFreeTry: false,
  showDiscount: 0,
  showCountryAd: false,
  getShowCountryAd() {
    FTGetAdShowCountry().then(res => {
      let { code, data } = res
      if(code === "000") {
        this.showCountryAd = res.data.block
      } else {
        this.showCountryAd = false
      }
    })
  },
  setUserInfo(data: object) {
    this.userInfo = data
  },
  setIsVip(bool: boolean) {
    this.isVip = bool
  },
  setIsSvip(bool: boolean) {
    this.isSvip = bool
  },
  showLogin({isSignIn, options, isShowScenses, otherParam, callback,errorCallBack}) {
    utils.loadLoginScript().then(() => {
      let signType = isSignIn ? "login" : "signUp";
      let position = (options && options.position) || "";
      window.login &&
        window.login.showLogin(
          signType,
          (res: any) => {
            let { code, userInfo } = res;
            if (code === 0 || code === 1 || code === 2) {
              // 登陆成功回调
              this.userInfo = userInfo.data
              this.getUserActivity()
              this.getShowCountryAd()
              this.checkUserVip(callback)
            }
            else{
              errorCallBack&&errorCallBack()
            }
          },
          "",
          { position },
          isShowScenses,
          { ...otherParam }
        );
    });
  },

  loginOut() {
    window.login.FTLogout().then(() => {
      this.userInfo = null
      this.isVip = false
      this.isSvip = false
      this.getUserActivity()
      this.getShowCountryAd()
      FTImageStore.imageHD = false
    })
  },

  checkUserLogin(callback: any) {
    utils.loadLoginScript().then(() => {
      window.login && window.login.FTGetLoginState().then((res: any) => {
        if(res && res.code === "000") {
          this.userInfo = res.data
          this.checkUserVip(callback)
        }
      })
    });
  },

  checkUserVip(callback) {
    return FTGetSubscriptions().then((res: any) => {
      if(res && res.code === "000") {
        let sub = res.data || []
        if (
          sub.find((m: any) => m.productName === "fotor" && !m.expiration) ||
          this.userInfo.superFotor
        ) {
          this.isVip = true
        } else {
          this.isVip = false
        }

        if (sub.find((m: any) => m.productName === "pxbee" && !m.expiration)) {
          // 超级vip
          this.isVip = true
          this.isSvip = true
        } else {
          this.isSvip = false
        }
        if(this.isVip) {
          FTImageStore.imageHD = true
        } else {
          FTImageStore.imageHD = false
        }
      }
    }).finally(() => {
      callback && callback()
    })
  },
  showPaymnet({vipType, position, otherParam, callback,errorCallBack}) {
    // let isProd = process.env.REACT_APP_ENVIRONMENT === "production"
    // if(!otherParam.promotionId) {
    //   otherParam.promotionId = isProd ? 606 : 574
    // }
    utils.loadPaymentSdk().then(() => {
      if (window["Payment"]) {
        // * @param callback  回调参数
        // * @param priceTabId tabIndex 支付面板  0非vip选中pro  1非vip选中pro+ 2是pro升级到pro+ 默认为1
        // * @param fromFunction edit,design,college,other
        // * @param app_id 埋点用唯一的id
        // * @param id  domid(可选)
        // * @param sensorsData {position:''} 神策埋点数据
        window["Payment"].showPayment(
          (data: any) => {
            // -----------国外支付弹窗返回------------

            // {type:'fail',code:'001',action:'close'} 支付失败 ，001 价格面板，行为关闭
            // {type:'fail',code:'004',action:'close'} 支付失败 ，004stripe 面板，行为关闭
            // {type:'fail',code:'005',action:'close'} 支付失败 ，005 兑换效验成功页面，行为关闭

            // {type:'success',code:'006',action:'close'} 领取兑换码成功，006 兑换领取成功页面，行为关闭
            // {type:'success',code:'006',action:'complete'} 领取兑换码成功，006 兑换领取成功页面，行为点击完成按钮
            // {type:'fail',code:'007',action:'close'} 领取兑换码失败，007 兑换领取成功页面，行为关闭
            // {type:'fail',code:'007',action:'complete'} 领取兑换码失败，007 兑换领取成功页面，行为点击取消

            // {type:'success',code:'008',action:'close'} 购买成功,008 购买成功页面，行为关闭
            // {type:'success',code:'008',action:'complete'} 购买成功,008 购买成功页面，行为点击购买成功按钮
            // fix: 存在这样一种情况，用户在支付过程中，如果操作过快，会出现没有拿到用户支持成功的情况，所以这边兼容一下，无论返回什么状态都更新一下用户信息
            let { type, code } = data;
            if (code === "006" || code === "007") {
              // 兑换码回调，不是支付，不管
              return;
            } else if (type === "success") {
              this.getUserActivity()
              this.checkUserLogin(callback)
              FTImageStore.imageHD = true
            }

            if(type==='fail'){
              errorCallBack&&errorCallBack()
            }
          },
          vipType === "svip" ? 1 : 0,
          "other",
          "",
          "",
          { position, project_type: "goart" },
          otherParam
        );
      }
    });
  },
  getUserActivity() {
    return FTGetUserPanelType().then(res => {
      if(res && res.code === "000") {
        let { activity, vipStatus } = res.data
        if(!activity) {
          this.showDiscount = 0
          this.showFreeTry = false
        } else {
          if(['try', 'try_discount'].includes(activity.favorType)) {
            this.showDiscount = 0
            this.showFreeTry = true
          } else if(activity.favorType === "discount" && vipStatus === 0) {
            this.showFreeTry = false
            this.showDiscount = activity.discountPercent
          } else {
            this.showFreeTry = false
            this.showDiscount = 0
          }
        }
      }
    })
  }
})

export default FTUserStore